var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.466,
    height: 40,
    rx: 8,
    fill: "#155EEF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5007 18.04C26.8251 14.59 23.8151 12 20.199 12C17.328 12 14.8345 13.64 13.5928 16.04C10.6026 16.36 8.27795 18.91 8.27795 22C8.27795 25.31 10.9503 28 14.2385 28H27.153C29.8948 28 32.1201 25.76 32.1201 23C32.1201 20.36 30.0835 18.22 27.5007 18.04ZM27.153 26H14.2385C12.043 26 10.2648 24.21 10.2648 22C10.2648 19.95 11.7847 18.24 13.8014 18.03L14.8643 17.92L15.361 16.97C16.3048 15.14 18.1526 14 20.199 14C22.8018 14 25.0469 15.86 25.5535 18.43L25.8516 19.93L27.3715 20.04C28.9212 20.14 30.1332 21.45 30.1332 23C30.1332 24.65 28.7921 26 27.153 26ZM16.2253 21H18.7585V24H21.6395V21H24.1727L20.199 17L16.2253 21Z",
    fill: "#155EEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 24,
    fill: "white",
    transform: "translate(6.23303 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadScan);
export default __webpack_public_path__ + "static/media/upload-scan.fa39a8af737d3ea100486edcf36594a3.svg";
export { ForwardRef as ReactComponent };